import React from 'react';

const InsightsAI = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8795_153621)">
      <path
        d="M0.306215 9.62316L3.07969 8.95226C4.85368 8.51297 5.89299 7.43566 6.38079 6.08192L7.60128 1.62026C7.63313 1.5321 7.71078 1.41406 7.94971 1.41406C8.1508 1.41406 8.26628 1.5321 8.29813 1.62026L9.51862 6.08341C10.0084 7.43715 11.0457 8.51447 12.8197 8.95376L15.5932 9.62465C15.9854 9.72028 15.9914 10.1357 15.6012 10.2358L12.8078 10.9575C11.0398 11.3983 10.0084 12.4741 9.51862 13.8218L8.29614 18.2342C8.26429 18.3223 8.19858 18.4807 7.94771 18.4807C7.68291 18.4807 7.63114 18.3223 7.59929 18.2342L6.37681 13.8218C5.88702 12.4726 4.85567 11.3968 3.08766 10.9575L0.294269 10.2358C-0.0919876 10.1342 -0.0860138 9.71879 0.306215 9.62316Z"
        fill="url(#paint0_linear_8795_153621)"
      />
      <path
        d="M0.0446362 9.80141C0.0884385 9.71923 0.174054 9.64751 0.307451 9.61464L3.08093 8.94375C4.85492 8.50445 5.89423 7.42714 6.38202 6.0734L7.60251 1.61174C7.62043 1.56094 7.68415 1.4683 7.75781 1.44141L7.36359 5.9195C7.07091 7.96356 6.82005 8.92582 4.64586 9.20673C2.77829 9.44878 0.618047 9.7267 0.0446362 9.80141Z"
        fill="url(#paint1_linear_8795_153621)"
      />
      <path
        d="M0.04284 10.0352L4.85312 10.8629C6.54747 11.1857 7.48125 11.9223 7.48125 13.8498L7.95312 18.4729C7.79185 18.4609 7.66045 18.3952 7.6047 18.2263L6.38222 13.814C5.89243 12.4647 4.86108 11.3889 3.09307 10.9496L0.29968 10.2279C0.168273 10.192 0.084651 10.1188 0.04284 10.0352Z"
        fill="url(#paint2_linear_8795_153621)"
      />
      <path
        d="M14.3525 3.98542C15.8145 3.52708 15.9478 3.01042 16.1935 2.13875L16.806 0.09875C16.8429 -0.0329167 17.2044 -0.0329167 17.243 0.09875L17.659 1.98375C17.9064 2.85208 18.4329 3.54208 19.3315 3.82375L20.7636 4.41375C20.9619 4.47542 20.9654 4.74208 20.7671 4.80542L19.3245 5.29042C18.4294 5.57208 17.9064 6.26208 17.6572 7.12708L17.2413 8.93042C17.2027 9.06208 16.8429 9.06208 16.806 8.93042L16.3181 7.13542C16.0707 6.26542 15.6916 5.57375 14.4754 5.29042L13.1205 4.80542C12.9222 4.74042 12.924 4.47375 13.124 4.41208L14.3525 3.98542Z"
        fill="url(#paint3_linear_8795_153621)"
      />
      <path
        d="M16.6891 2.10625C16.5399 3.41625 16.4644 3.77958 15.3465 4.05125L13.0176 4.48291C13.0422 4.45125 13.0773 4.42458 13.1247 4.41125L14.3532 3.98291C15.6361 3.56625 15.9906 3.03625 16.231 1.97625C16.4715 0.916246 16.7277 0.22458 16.7277 0.22458C16.8172 -0.00375338 16.9453 0.00791278 16.9453 0.00791278L16.6891 2.10625Z"
        fill="url(#paint4_linear_8795_153621)"
      />
      <path
        d="M16.6416 6.68453C16.6416 5.44953 15.9308 4.83787 14.8006 4.83787L13.0421 4.76953C13.0421 4.76953 13.1439 4.89786 13.3211 4.93786L14.4689 5.29286C15.4429 5.66453 15.8869 5.8512 16.1888 7.1162C16.1888 7.1162 16.5784 8.58786 16.6521 8.74286C16.7539 8.95953 16.875 9.00453 16.875 9.00453L16.6416 6.68453Z"
        fill="url(#paint5_linear_8795_153621)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_8795_153621"
        x1="7.29214"
        y1="14.2323"
        x2="10.9471"
        y2="-8.80567"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00E9B1" />
        <stop offset="1" stop-color="#8457E5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8795_153621"
        x1="3.58201"
        y1="7.72034"
        x2="5.38706"
        y2="-3.55986"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00E9B1" />
        <stop offset="1" stop-color="#8457E5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_8795_153621"
        x1="3.67061"
        y1="16.3724"
        x2="5.46496"
        y2="4.97846"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00E9B1" />
        <stop offset="1" stop-color="#8457E5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_8795_153621"
        x1="16.6148"
        y1="6.78152"
        x2="18.6548"
        y2="-5.3711"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00E9B1" />
        <stop offset="1" stop-color="#8457E5" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_8795_153621"
        x1="14.8189"
        y1="3.36892"
        x2="15.832"
        y2="-2.65356"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00E9B1" />
        <stop offset="1" stop-color="#8457E5" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_8795_153621"
        x1="14.7999"
        y1="7.95031"
        x2="15.7312"
        y2="2.24159"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00E9B1" />
        <stop offset="1" stop-color="#8457E5" />
      </linearGradient>
      <clipPath id="clip0_8795_153621">
        <rect
          width="21.1765"
          height="20"
          fill="white"
          transform="matrix(-1 0 0 1 21.1797 0)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default InsightsAI;
